import React, { useState } from 'react';
import CommonDropdown from 'components/Elements/CommonDropdown';
import PrintIcon from 'assets/printer.svg';
import { useReport } from '../ReportContext';
import { useFilters } from 'components/Elements/Filters/FilterContext';
import { getCMDataExport } from 'services/reports/reports';
import { fileDownload, getFileNameFromContentDispositonHeader } from 'helpers/utils';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';

export const ReportHeader = () => {
	const { config } = useReport();
	const { buildUrlParams, siteAppId } = useFilters();
	const dispatch = useDispatch();
	const [isDownloading, setIsDownloading] = useState(false);

	if (!config.csvExport?.enabled) {
		return null;
	}

	const reports = [
		{
			id: '1',
			name: config.csvExport.label || 'CM Data Export',
			reportType: 'CM_DATA_EXPORT',
		},
	];

	const downloadReportHandler = async (reportToBeDownloaded, handleClose) => {
		if (Object.keys(reportToBeDownloaded)?.length < 1) {
			return;
		}
		handleClose();

		try {
			setIsDownloading(true);
			const filterParams = buildUrlParams();
			const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
			const questionIds = config.csvExport.getQuestionIds?.(filterParams);

			const payload = {
				...filterParams,
				siteAppId,
				timeZone,
				modelVersionTaskQuestionIds: questionIds,
				modelIds: filterParams.modelId ? [filterParams.modelId] : [],
			};

			const response = await getCMDataExport(payload);

			if (response?.status) {
				const fileName = getFileNameFromContentDispositonHeader(response);
				fileDownload(response, fileName);
			} else {
				const res = JSON.parse(await response?.data?.text());
				dispatch(
					showError(
						res?.detail || res?.errors?.message || 'Failed to download report.'
					)
				);
			}
		} catch (err) {
			dispatch(showError('Failed to download report.'));
		} finally {
			setIsDownloading(false);
		}
	};

	return (
		<CommonDropdown
			iconSrc={PrintIcon}
			isDownloading={isDownloading}
			dataSource={reports}
			dynamicAction={downloadReportHandler}
		/>
	);
};
